export default __webpack_public_path__ + "static/media/disciplinate.7d93b250.svg";